/* @flow */
// typecheck: ignore file
import AdminVerificationModals from 'admin/components/AdminVerificationModals.jsx';
import AppTopBarContainer from 'app/containers/AppTopBarContainer.jsx';
import ClassNavigation from 'groups/components/ClassNavigation.jsx';
import QuickPromotionAppOpenedModals from 'components/QuickPromotionAppOpenedModals.jsx';
import BannersContainer from 'components/banners/BannersContainer.jsx';
import React from 'react';
import TymkRegistrationModals from 'user/components/TymkRegistrationModals.jsx';
import ProfileCompletenessModals from 'user/components/ProfileCompletenessModals.jsx';
import User from 'entities/User';

import { markSeenClasses } from 'utils/accountCompletionTracker';
import { unauthorizedInterceptor } from 'lib/ResponseInterceptors';

import { registerInterceptor, unregisterInterceptor } from 'singletons/xhrInterceptors';

import styles from './styles/AppLayout.css';

type Props = {
  user: ?User,
  location: Object,
  children?: ?any,
}

class AppLayout extends React.Component {
  props: Props;

  static contextTypes = {
    router: React.PropTypes.object.isRequired,
  };

  componentDidMount() {
    registerInterceptor('401-interceptor', unauthorizedInterceptor);
    markSeenClasses(this.props.user);
  }

  componentWillUnmount() {
    unregisterInterceptor('401-interceptor');
  }

  render() {
    const shouldShowBanner = (
      this.props.user &&
      !this.context.router.isActive('/setup')
    );

    return (
      <div className={styles.this}>
        {shouldShowBanner && <BannersContainer data-test="banners-container" />}
        <div className={styles.bodyPadding}>
          <AppTopBarContainer />
          <div className={styles.heightSetter}>
            <div className={styles.contentWrap}>
              <div className={styles.sidebar}>
                <ClassNavigation />
              </div>
              <div className={styles.content}>
                {this.props.children}
              </div>
            </div>
          </div>
        </div>
        <AdminVerificationModals location={this.props.location} />
        <QuickPromotionAppOpenedModals />
        <TymkRegistrationModals />
        <ProfileCompletenessModals />
      </div>
    );
  }
}

export default AppLayout;



// WEBPACK FOOTER //
// ./src/app/components/AppLayout.jsx